import React from "react";
import { Box, TextField } from "@mui/material";
import "emoji-mart/css/emoji-mart.css";
import { Field } from "react-final-form";

const RubricTagEditFields = () => {
  return (
    <Box sx={{ padding: "0 20px" }}>
      <Box sx={{ position: "relative" }}>
        <Field name="name">
          {({ input }) => (
            <TextField
              {...input}
              id="standard-multiline-flexible"
              label="Rubric name"
              fullWidth
              multiline
              maxRows={6}
              rows={3}
              sx={{
                marginTop: "20px",
              }}
              variant="outlined"
            />
          )}
        </Field>
      </Box>
    </Box>
  );
};

export default RubricTagEditFields;
